import { useMemo } from 'react';

import { Dropdown, DropdownSearch, ListItemSelectAll } from 'component-library';
import { toDropdownItems, userSearchItems } from './utils';
import { UserList } from './components/UserList';
import { type UserPickerItem } from './types';

export type UserPickerProps = {
  users: UserPickerItem[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  searchPlaceholder?: string;
  label?: string;
  loading?: boolean;
  disabled?: boolean;
  maxSelections?: number;
  showSelectAll?: boolean;
  showSearch?: boolean;
  required?: boolean;
  errorMessage?: string;
  error?: boolean;
};

const SEARCH_THRESHOLD = 7;

export const UserPicker = ({
  users,
  selectedValues,
  onChange,
  placeholder,
  searchPlaceholder,
  label,
  loading = false,
  disabled = false,
  maxSelections,
  showSelectAll = true,
  showSearch = true,
  required,
  errorMessage,
  error,
}: UserPickerProps) => {
  const dropdownItems = useMemo(() => toDropdownItems(users), [users]);

  const showSearchField = showSearch && users.length > SEARCH_THRESHOLD;

  return (
    <Dropdown
      items={dropdownItems}
      selectedValues={selectedValues}
      onChange={onChange}
      multiSelect={true}
      placeholder={placeholder ?? 'Select users'}
      searchPlaceholder={searchPlaceholder ?? 'Search users'}
      label={label}
      loading={loading}
      disabled={disabled}
      required={required}
      errorMessage={errorMessage}
      error={error}
      customSearch={userSearchItems}
    >
      {showSearchField && <DropdownSearch />}
      {showSelectAll && <ListItemSelectAll />}
      <UserList maxSelections={maxSelections} />
    </Dropdown>
  );
};

export type { UserPickerItem, UserPickerBadge } from './types';
